import { createFileRoute } from '@tanstack/react-router';
import { TenantsTable } from '../../pages/platform/tenants/TenantsTable';

export const Route = createFileRoute('/_authenticated/_layout/platform/tenants/')({
    component: () => <TenantsTable />,
});
